module.exports = {"title":"Domain Model","body":"<p>This is the domain model for the Tax Efficient Retirement Income project.</p>\n<p><img src=\"../files/DomainModel.png\" alt=\"Picture of domain model\"></p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./deliverables/domain-model/index.md
 ** module id = 467
 ** module chunks = 0
 **/